<template>
  <div class="menu-wrapper menuList"  ref = "menuList" id="menuList">
     <img src="../../../../assets/images/logo.png" alt=""  class="img" v-show="!isCollapse"/>
     <img src="../../../../assets/images/logo2.png" alt="" width="20" v-show="isCollapse" />
    <template v-for="(item,index) in routes" >
      <template v-if="!item.hidden&&item.children">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="index">
  
        <el-menu-item :style="{}" :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        {{item.name}}
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" >
          <template v-if="!child.hidden">
          <sidebar-item  :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
        </template>
      </el-submenu>
    </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
  },
  watch:{
    $route(val){
      // id="menuList"
      // debugger
      if(val.path === '/helpCenter' || val.path ==='/updatePassWord'){
        // alert(3234)
        this.$refs.menuList.classList.remove('menuList' )
         this.$refs.menuList.setAttribute("id", "")
      }else{
        this.$refs.menuList.classList.add('menuList')
        this.$refs.menuList.setAttribute("id", "menuList")
      }
    }
  },
  mounted(){
    
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>
<style >



.menuList .el-menu-item.is-active{
  background: #409eff !important;
}

#menuList .el-submenu.is-active .el-menu-item.is-active{
   background: #409eff !important;
   display: inline-block;
}
.menu-wrapper .el-submenu .el-menu-item span{
  margin-left:-20px !important;
}
</style>
<style scoped>
.img {
  width: 120px;
 
  /* margin-bottom:40px; */
}
img{
 margin: 12px auto;
  display: flex;
 
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue